var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "countersign" },
    [
      _c(
        "div",
        { staticClass: "addnum" },
        [
          _vm.$route.query.isBanner == 0 && _vm.$route.query.isApp == 1
            ? _c("van-icon", {
                attrs: {
                  id: "backIcon",
                  name: _vm.isDirection ? "arrow" : "arrow-left"
                },
                on: {
                  click: function($event) {
                    return _vm.$router.back()
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", {
            staticClass: "p-content",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("300163", {
                  num: _vm.usersignMsg.availableCountersignNum
                })
              )
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "p-link", on: { click: _vm.tomoney } }, [
            _vm._v(_vm._s(_vm.$t("300164"))),
            _c("i", {
              class: _vm.isDirection
                ? "iconfont icon-left"
                : "iconfont icon-right"
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "datarender" },
            _vm._l(_vm.usersignMsg.signDateList, function(item, index) {
              return _c(
                "dl",
                {
                  key: index,
                  class: {
                    nosign:
                      item.status == 1 || item.status == 3 || item.status == 0
                  }
                },
                [
                  _c("dt", [
                    _c("img", {
                      attrs: {
                        src: _vm.getImgurl(
                          _vm.giftday[index],
                          ".png",
                          item.status
                        ),
                        alt: ""
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          item.signDate
                            .split("-")
                            .slice(1)
                            .join(".")
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.status === 1,
                          expression: "item.status === 1"
                        }
                      ],
                      staticClass: "dialog",
                      on: {
                        click: function($event) {
                          return _vm.addsigns(item.signDate, index)
                        }
                      }
                    },
                    [
                      _c("div", [
                        _c("span", [_vm._v(_vm._s(_vm.$t("300165")))])
                      ])
                    ]
                  )
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "reward",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.isget,
            callback: function($$v) {
              _vm.isget = $$v
            },
            expression: "isget"
          }
        },
        [
          _vm.isshow
            ? _c("div", { staticClass: "Tipsdialog" }, [
                _c("div", { staticClass: "Tips" }, [
                  _c("p", [
                    !_vm.usersignMsg.isGetCountersign
                      ? _c(
                          "svg",
                          {
                            staticClass: "icon",
                            attrs: { slot: "image", "aria-hidden": "true" },
                            slot: "image"
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-tishi-1" }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.usersignMsg.isGetCountersign
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("300166")))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.usersignMsg.isGetCountersign
                    ? _c("div", { staticClass: "main p" }, [
                        _c("p", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("300168", {
                                  num: _vm.signconfig.rechargeAmount,
                                  symbol: "USDT"
                                })
                              ) +
                              "\n          "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.usersignMsg.isGetCountersign
                    ? _c("div", { staticClass: "main p" }, [
                        _c("p", [_vm._v(_vm._s(_vm.$t("300170")))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.usersignMsg.isGetCountersign
                    ? _c(
                        "div",
                        { staticClass: "OK", on: { click: _vm.closedialog } },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("300141")))])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.usersignMsg.isGetCountersign
                    ? _c("div", { staticClass: "foot" }, [
                        _c(
                          "span",
                          {
                            staticClass: "left",
                            on: { click: _vm.closedialog }
                          },
                          [_vm._v(_vm._s(_vm.$t("300111")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "right", on: { click: _vm.tomoney } },
                          [_vm._v(_vm._s(_vm.$t("300102")))]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("ReceiveDialog", {
            attrs: {
              addtitle: _vm.title,
              receive: _vm.receive,
              closegift: _vm.closegift,
              getconfig: _vm.getconfig
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cc804f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cc804f0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Countersign.vue
// module id = JU5+
// module chunks = 0